import { Box, Center } from '@chakra-ui/react';

const SiteHeaderWrapper = ({ children }) => {
  return (
    <Center
      height={['64px']}
      width="100vw"
      paddingLeft={['20px', '40px', '80px']}
      paddingRight={['20px', '40px', '80px']}
      backgroundColor="BLACK"
    >
      <Box
        display="flex"
        width="100%"
        maxWidth="1400px"
        height="100%"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        {children}
      </Box>
    </Center>
  );
};
export default SiteHeaderWrapper;